import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PageChanger from "../Helpers/Components/Pagination1"
import Handler from "../Helpers/Components/Handler"
import moment from "moment";
import TablePlaceHolder from "../Helpers/Components/TablePlaceHolder"
import DatePicker from "react-multi-date-picker";
import { DropdownToggle, DropdownButton, DropdownLink } from '../Helpers/Components/Dropdown';
import { toast } from "react-toastify";
import Modal from "../Helpers/Components/Modal";
import { getCookie, reloadWindow } from "../Helpers/Utils";
import Select from 'react-select'
import CustInformation from "../Helpers/Components/CustInformation";

const List = () => {
    const [pageNo, setPage] = useState(1)
    const navigate = useNavigate()
    const [element, setElement] = useState()
    const [info, setInfo] = useState(false)
    const requestRef = useRef(0);
    const [next, setNext] = useState(false)
    const [cancel, setCancel] = useState({ booking: "", remarks: "" })
    const [loading, setLoading] = useState(false)
    const [cart, setCart] = useState(localStorage.getItem('filter'));
    const [bookingDetails, setBookingDetails] = useState([])
    const [total, setTotal] = useState(0)
    const [subadminList, setSubadminList] = useState([])
    const [leadList, setLeadList] = useState([])
    const [checkDate, setCheckDate] = useState(cart ? JSON?.parse(cart)?.checkDate ? JSON?.parse(cart)?.checkDate : "" : "")
    const [picheckDate, setPicheckDate] = useState(cart ? JSON?.parse(cart)?.picheckDate ? JSON?.parse(cart)?.picheckDate : "" : "")
    const person = getCookie('person')
    const [modal, showModal] = useState(false)
    const calendarRef = useRef();
    const [carDetails, setCarDetails] = useState([])
    const calendarRef1 = useRef();
    const kycOf = (list, type) => (Array.isArray(list) ? list.find((k) => k?.type === type) : undefined);
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsgeet.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const [filter, setFilter] = useState({
        count: cart ? JSON?.parse(cart)?.count ? JSON?.parse(cart)?.count : 10 : 10,
        sortBy: "deliveryDetails.delivery",
        sort: true,
        search: cart ? JSON?.parse(cart)?.search ? JSON?.parse(cart)?.search : "" : "",
        createdBy: cart ? JSON?.parse(cart)?.createdBy ? JSON?.parse(cart)?.createdBy : "All" : "All",
        deliveryBy: cart ? JSON?.parse(cart)?.deliveryBy ? JSON?.parse(cart)?.deliveryBy : "All" : "All",
        carId: cart ? JSON?.parse(cart)?.carId ? JSON?.parse(cart)?.carId : "All" : "All",
        remarks: cart ? JSON?.parse(cart)?.remarks ? JSON?.parse(cart)?.remarks : "All" : "All",
        pickupBy: cart ? JSON?.parse(cart)?.pickupBy ? JSON?.parse(cart)?.pickupBy : "All" : "All",
        status: cart ? JSON?.parse(cart)?.status ? JSON?.parse(cart)?.status : "All" : "All",
        type: cart ? JSON?.parse(cart)?.type ? JSON?.parse(cart)?.type : "All" : "All",
        leadMode: cart ? JSON?.parse(cart)?.leadMode ? JSON?.parse(cart)?.leadMode : { label: "All", value: "All" } : { label: "All", value: "All" },
        leadAttendedBy: cart ? JSON?.parse(cart)?.leadAttendedBy ? JSON?.parse(cart)?.leadAttendedBy : { label: "All", value: "All" } : { label: "All", value: "All" }
    })
    const handleOpen = () => {
        if (calendarRef.current) {
            calendarRef.current.openCalendar();
        }
    };
    const handleOpen1 = () => {
        if (calendarRef1.current) {
            calendarRef1.current.openCalendar();
        }
    };
    const sort = (sortBy, sort) => {
        setPageNo(1)
        setFilter((prev) => ({
            ...prev,
            sortBy: sortBy,
            sort: sort
        }))
    }
    const setPageNo = (value) => {
        setPage(value)
    }
    const handleChange = (e) => {
        setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        setPageNo(1)
    }
    const getBookingDetails = async () => {
        const currentRequestId = ++requestRef.current;
        setLoading(true);
        let data = {};
        if (filter?.search) data.search = filter.search;
        if (filter?.leadMode?.label !== "All") data.leadMode = filter.leadMode.value;
        if (filter?.leadAttendedBy?.label !== "All") data.leadAttendedBy = filter.leadAttendedBy.value;
        if (filter?.carId !== "All") data.carId = filter.carId;
        if (checkDate?.length) {
            data.deliveryFrom = moment(checkDate[0]).format("DD-MM-YYYY");
            data.deliveryTo = moment(checkDate[1] || checkDate[0]).format("DD-MM-YYYY");
        }
        if (picheckDate?.length) {
            data.pickupFrom = moment(picheckDate[0]).format("DD-MM-YYYY");
            data.pickupTo = moment(picheckDate[1] || picheckDate[0]).format("DD-MM-YYYY");
        }
        if (filter.deliveryBy !== "All") data.deliveryBy = filter.deliveryBy;
        if (filter.pickupBy !== "All") data.pickupBy = filter.pickupBy;
        if (filter.status !== "All") data.status = [filter.status];
        if (filter.remarks !== "All") data.remarks = filter.remarks;
        const response = await Handler({
            method: "post",
            url: `/booking/${Object.keys(data)?.length > 0 ? "list" : "searching"}/${pageNo}?count=${filter?.count || 10}`,
            data: { ...data, sort: filter.sort, sortBy: filter.sortBy }
        });
        if (currentRequestId !== requestRef.current) return;
        if (response?.success) {
            setBookingDetails(response.data.current);
            setNext(response.data.next);
            setTotal(response.data.total);
        } else {
            setBookingDetails([]);
            setNext(false);
            setTotal(0);
        }
        setLoading(false);
    };
    const getLeadList = async () => {
        const response = await Handler({ method: "get", url: `/booking/lead-list`, })
        if (response?.success) {
            setLeadList([...(response?.data?.length ? response?.data?.map((element) => { return { label: element?.name?.toUpperCase(), value: element?.leadId } }) : []), { label: "All", value: "All" }])
        } else {
            setLeadList([])
        }
    }
    const getSubadminList = async () => {
        const response = await Handler({ method: "get", url: `/customer/details/get-subadmin`, })
        if (response?.success) {
            setSubadminList(response?.data)
        } else {
            setSubadminList([])
        }
    }
    const setFilteration = (name, value) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, [name]: value }))
        setItem(name, value)
    }
    const handleToggle = (element) => {
        setElement(element);
        setInfo(true)
    }
    const getDays = (delivery, pickup) => {
        let diff = ((new Date(pickup).getTime() - new Date(delivery).getTime()) / 1000) / 3600;
        if (Math.ceil(diff / 12) / 2 == 0.5) {
            return 1
        } else {
            if (Math.ceil(diff / 12) % 2 !== 0) {
                let to = new Date(pickup)
                to?.setHours(new Date(pickup)?.getHours() - 2)
                let diff1 = ((to?.getTime() - new Date(delivery).getTime()) / 1000) / 3600
                if (Math.ceil(diff1 / 12) % 2 !== 0) {
                    return Number(Math.floor(Math.ceil(diff / 12) / 2)) + 0.5
                }
            }
            return Number(Math.floor(Math.ceil(diff / 12) / 2))
        }
    }
    const cancelBooking = async () => {
        if (!cancel?.remarks) {
            toast.error("Remarks is required")
        } else {
            setLoading(true)
            const response = await Handler({ method: "patch", url: `/booking/details/cancel/${cancel?.booking}`, data: { remarks: cancel?.remarks } })
            if (response?.success) {
                toast.success(response?.message)
                showModal(false)
                setTimeout(() => {
                    reloadWindow()
                    setLoading(false)
                }, 1500);
            } else {
                toast.error(response?.message)
                setLoading(false)
            }
        }
    }
    const clearAll = () => {
        setPageNo(1)
        setFilter((prev) => ({
            ...prev,
            count: 10,
            sortBy: "deliveryDetails.delivery",
            sort: true,
            search: "",
            createdBy: "All",
            deliveryBy: "All",
            remarks: "All",
            pickupBy: "All",
            status: "All",
            carId: "All",
            type: "All",
            leadMode: { label: "All", value: "All" },
            leadAttendedBy: { label: "All", value: "All" }
        }))
        localStorage.removeItem('filter')
        setCheckDate({})
        setPicheckDate({})
    }
    const setItem = (name, value) => {
        const existing = localStorage.getItem('filter');
        let oldData = existing ? JSON.parse(existing) : {};
        oldData[name] = value || "";
        localStorage.setItem('filter', JSON.stringify(oldData));
    };
    const getCarDetails = async () => {
        const response = await Handler({ method: 'get', url: `/car/list` })
        if (response?.success) {
            setCarDetails(response?.data)
        } else {
            setCarDetails([])
        }
    }
    const checkDelivery = async (booking) => {
        const date = new Date(new Date(booking?.deliveryDetails?.delivery)?.setHours(0, 0, 0))
        const today = new Date()
        if (today >= date) {
            navigate(`/booking/delivery/${booking?.bookingId}`)
        } else {
            toast.error("Delivery can't be made")
        }
    }
    const proof = useMemo(() => {
        if (!element) return null;
        const dl = kycOf(element.kyc, "dl");
        const aadhaar = kycOf(element.kyc, "aadhaar");
        const passport = kycOf(element.kyc, "passport");
        const coDl = kycOf(element.otherKyc, "dl");
        const coAadhaar = kycOf(element.otherKyc, "aadhaar");
        const coPassport = kycOf(element.otherKyc, "passport");
        return {
            phone: (element?.phone || []).filter((p) => p?.status).length >= (element?.custType === "local" ? 3 : 2),
            dl, aadhaar, passport, coDl, coAadhaar, coPassport,
            hasCoPassenger: Boolean(element.secPhoto || (coDl?.photo?.length >= 2) || (coAadhaar?.photo?.length >= 2) || (coPassport?.photo?.length >= 3)),
        };
    }, [element]);
    useEffect(() => {
        getBookingDetails()
    }, [pageNo, filter, checkDate, picheckDate])
    useEffect(() => {
        getSubadminList()
        getLeadList()
        getCarDetails()
    }, [])
    return (
        <React.Fragment>
            <div className="row justify-content-between align-items-center">
                <div className="col-lg-4">
                    <div className="input-group mb-3">
                        <input type="text" className="form-control search-input" autoComplete="off" placeholder="Search..." value={filter?.search} onChange={handleChange} name="search" />
                        <span className="input-group-text cancel-icon">{filter?.search ? <i className="fa-solid fa-circle-xmark cursor-pointer text-theme" onClick={() => { setFilter((prev) => ({ ...prev, search: "" })); setPageNo(1) }}></i> : ""}</span>
                    </div>
                    <div>Total Booking: {total}</div>
                </div>
            </div>
            <div className='overflow list-table mt-3'>
                <table className="table-bg table" borderless="true">
                    <thead>
                        <tr className="border-bottom" >
                            <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "bookingId" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("bookingId", false)} >▲</i><i className={filter?.sortBy === "bookingId" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("bookingId", true)} >▼</i></div> Id</div></th>
                            <th className="sticky-cust">Cust</th>
                            <th>
                                <DropdownToggle label={
                                    <>
                                        Car ID <i className="fa-solid fa-caret-down"></i>
                                    </>
                                }>
                                    <DropdownButton label="All" className={`${filter?.carId === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("carId", "All") }} />
                                    {
                                        carDetails?.length ?
                                            carDetails?.map((element, i) => {
                                                return (
                                                    <DropdownButton key={i} label={element?.carId} className={`${filter?.carId === element?.id ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("carId", element?.id) }} />
                                                )
                                            })
                                            : ""
                                    }
                                </DropdownToggle>
                            </th>
                            <th className="text-center">
                                <DropdownToggle label={
                                    <>
                                        Status <i className="fa-solid fa-caret-down"></i>
                                    </>
                                }>
                                    <DropdownButton label="All" className={`${filter?.status === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "All") }} />
                                    <DropdownButton label="Booked" className={`${filter?.status === "Booked" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Booked") }} />
                                    <DropdownButton label="Cancelled" className={`${filter?.status === "Cancelled" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Cancelled") }} />
                                    <DropdownButton label="Ongoing" className={`${filter?.status === "Ongoing" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Ongoing") }} />
                                    <DropdownButton label="Pending" className={`${filter?.status === "Pending" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Pending") }} />
                                    <DropdownButton label="Completed" className={`${filter?.status === "Completed" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Completed") }} />
                                    <DropdownButton label="Verified" className={`${filter?.status === "Verified" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Verified") }} />
                                </DropdownToggle>
                            </th>
                            <th> Action </th>
                            <th> <div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "deliveryDetails.delivery" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("deliveryDetails.delivery", false)} >▲</i><i className={filter?.sortBy === "deliveryDetails.delivery" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("deliveryDetails.delivery", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen() }}> DL <i className="fa-solid fa-caret-down"></i> </button>  </div>  </th>
                            <th> <div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "pickupDetails.pickup" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("pickupDetails.pickup", false)} >▲</i><i className={filter?.sortBy === "pickupDetails.pickup" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("pickupDetails.pickup", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen1() }}> PK <i className="fa-solid fa-caret-down"></i> </button>  </div>  </th>
                            <th>
                                <DropdownToggle label={
                                    <>
                                        Delivery By <i className="fa-solid fa-caret-down"></i>
                                    </>
                                }>
                                    <DropdownButton label="All" className={`${filter?.deliveryBy === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("deliveryBy", "All") }} />
                                    {
                                        subadminList?.length ?
                                            subadminList?.map((element, i) => {
                                                return (
                                                    <DropdownButton key={i} label={element?.name} className={`${filter?.deliveryBy === element?.id ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("deliveryBy", element?.id) }} />
                                                )
                                            })
                                            : ""
                                    }
                                </DropdownToggle>
                            </th>
                            <th>
                                <DropdownToggle label={
                                    <>
                                        Pickup By <i className="fa-solid fa-caret-down"></i>
                                    </>
                                }>
                                    <DropdownButton label="All" className={`${filter?.pickupBy === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("pickupBy", "All") }} />
                                    {
                                        subadminList?.length ?
                                            subadminList?.map((element, i) => {
                                                return (
                                                    <DropdownButton key={i} label={element?.name} className={`${filter?.pickupBy === element?.id ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("pickupBy", element?.id) }} />
                                                )
                                            })
                                            : ""
                                    }
                                </DropdownToggle>
                            </th>
                            <th>
                                <DropdownToggle label=
                                    {<>
                                        Remarks <i className="fa-solid fa-caret-down"></i>
                                    </>}>
                                    <DropdownButton label="All" className={`${filter?.remarks === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "All") }} />
                                    <DropdownButton label="Good" className={`${filter?.remarks === "Good" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "Good") }} />
                                    <DropdownButton label="Bad" className={`${filter?.remarks === "Bad" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "Bad") }} />
                                </DropdownToggle>
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        {!loading ?
                            (bookingDetails && bookingDetails?.length !== 0 ? bookingDetails?.map((value, key) => {
                                return (
                                    <tr key={key} className={`table-content-row ${value?.status === "Pending" || value?.status === "Cancelled" || (value?.carStatus === false && value?.status !== "Completed") || (value?.excessCharges?.length && value?.excessCharges?.filter(element => element?.name === "damage")?.length && Number(value?.excessCharges?.filter(element => element?.name === "damage")[0]?.amount) > 0) || (value.pendingPhoto?.length > 0) ? "text-red" : ""}`}>
                                        <td><a className="" href={`/booking/view/${value?.bookingId}`}>{value?.verified ? <i className="fa-solid fa-circle-check text-success"></i> : ""} {value?.bookingId}</a></td>
                                        <td className="sticky-cust">
                                        <i className="fa-solid fa-circle-info cursor-pointer me-1" onClick={() => { handleToggle(value) }}></i>
                                            <a href={`/customer/view/${value?.customerId}`} className="sticky-text">
                                                {value?.customerId}
                                            </a>
                                            <div className="text-capitalize sticky-text">
                                                {(value?.firstName || "") + " " + (value?.lastName || "")}
                                            </div>
                                        </td>
                                        <td>{value?.carId}</td>
                                        <td className={`${value?.status === "Completed" ? "text-green" : value?.status === "Ongoing" ? "text-yellow" : value === "Pending" ? "text-red" : ""} fw-bold text-center`}>
                                            <div className="d-flex flex-column align-items-center">
                                                <span>{value?.status || "-"}</span>
                                                {value?.verified ? <span className="verified-text">Verified</span> : ""}
                                                {value?.pendingPhoto?.length && value?.status === "Completed" ? <span className="verified-text">Pending & Closed</span> : ""}
                                            </div>
                                        </td>
                                        <td>
                                            {
                                                value?.bookingId ?
                                                    value?.status === "Cancelled" ? "-" :
                                                        value?.status === "Completed" ? <Link to={`/booking/invoice/${value?.bookingId}`} > Generate Bill </Link> :
                                                            <>
                                                                <DropdownToggle label={"Action"} className="dropdown-list-head">
                                                                    {
                                                                        value?.status === "Ongoing" || value?.status === "Pending" ?
                                                                            <DropdownButton onClick={() => navigate(`/booking/close/${value?.bookingId}`)} className="list-btns list-success-btn" label="Pickup" />
                                                                            : (value?.status === "Booked" && value?.carStatus) ?
                                                                                <DropdownButton className="list-btns list-success-btn" label="Delivery" onClick={() => { checkDelivery(value) }} /> :
                                                                                !value?.status ? <DropdownButton className="list-btns list-success-btn" label="Book" onClick={() => navigate(`/booking/update/${value?.bookingId}`)} /> : ""
                                                                    }
                                                                    {
                                                                        (value?.status === "Booked") ?
                                                                            <DropdownButton label="Cancel" className="list-btns list-danger-btn" onClick={() => { setCancel({ booking: value?.bookingId, remarks: "" }); showModal(true) }} />
                                                                            : value?.status === "Ongoing" ?
                                                                                <DropdownButton label="Pending" className="list-btns list-danger-btn" onClick={() => navigate(`/booking/pending/${value?.bookingId}`)} />
                                                                                : ""
                                                                    }
                                                                    {
                                                                        (value?.status === "Booked") ?
                                                                            <DropdownButton label="Edit" className="list-btns list-warning-btn" onClick={() => navigate(`/booking/update/${value?.bookingId}`)} />
                                                                            : value?.status === "Ongoing" ?
                                                                                <DropdownButton label="Edit" className="list-btns list-warning-btn" onClick={() => navigate(`/booking/delivery/${value?.bookingId}`)} />
                                                                                : ""
                                                                    }
                                                                </DropdownToggle>
                                                            </>
                                                    : <button className="btn btn-success btn-sm" onClick={() => navigate(`/booking/register`)}>Create Booking</button>
                                            }
                                        </td>
                                        <td>{value?.deliveryDetails?.delivery ? moment(new Date(value?.deliveryDetails?.delivery)).format("DD/MM/YYYY hh:mm A") : ""}
                                            <div className="text-uppercase">{value?.deliveryDetails?.location || ""}</div>
                                        </td>
                                        <td>{value?.pickupDetails?.pickup ? moment(new Date(value?.pickupDetails?.pickup)).format("DD/MM/YYYY hh:mm A") : ""}
                                            <div className="text-uppercase">{value?.pickupDetails?.location || ""}</div>
                                        </td>
                                        <td className="text-capitalize">{value?.stageHistory?.length ? value?.stageHistory?.filter(element => element?.stage === "Ongoing")?.length ? value?.stageHistory?.filter(element => element?.stage === "Ongoing")[0]?.staffName : "-" : "-"}</td>
                                        <td className="text-capitalize">{value?.stageHistory?.length ? value?.stageHistory?.filter(element => element?.stage === "Completed")?.length ? value?.stageHistory?.filter(element => element?.stage === "Completed")[0]?.staffName : "-" : "-"}</td>
                                        <td>{value?.remarks || "-"}</td>
                                    </tr>
                                )
                            }) :
                                <tr className='text-center' ><td colSpan={10}>No Data Found</td></tr>)
                            : <TablePlaceHolder count={10} />
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex align-items-center justify-content-end mt-3">
                   <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setFilteration("count", Number(selectedoption?.value))
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? {label: filter?.count, value: filter?.count} : {label: 10, value: 10}}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
            <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='booking' />
            <DatePicker
                ref={calendarRef}
                range
                className='rmdp-mobile'
                inputClass='d-none'
                onChange={(e) => { setPageNo(1); if (!isNaN(new Date(e[0]))) { setCheckDate(e); } }}
                value={checkDate}
                mobileButtons={[
                    {
                        label: "RESET",
                        type: "button",
                        className: "rmdp-button rmdp-action-button",
                        onClick: () => setCheckDate({}),
                    },
                ]}
            />
            <DatePicker
                ref={calendarRef1}
                range
                className='rmdp-mobile'
                inputClass='d-none'
                onChange={(e) => { setPageNo(1); if (!isNaN(new Date(e[0]))) { setPicheckDate(e); } }}
                value={picheckDate}
                mobileButtons={[
                    {
                        label: "RESET",
                        type: "button",
                        className: "rmdp-button rmdp-action-button",
                        onClick: () => setPicheckDate({}),
                    },
                ]}
            />
            <Modal header={element?.bookingId} onShow={info} toggle={() => setInfo(false)} overlayToggle={() => setInfo(false)}>
                <CustInformation element={element} proof={proof}/>
            </Modal>
            <Modal header={"Cancel Booking"} onShow={modal} toggle={() => showModal(false)} overlayToggle={() => showModal(false)}>
                Do you really wanna cancel the booking : {cancel?.booking}?
                <input placeholder="Remarks" autoComplete="off" className="form-control input-theme text-uppercase mt-3" onChange={(e) => setCancel((prev) => ({ ...prev, remarks: e.target.value }))} />
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-danger" onClick={cancelBooking}>Cancel Booking</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default List;